import { render } from "./StatusRegion.vue?vue&type=template&id=feed90c4"
import script from "./StatusRegion.vue?vue&type=script&lang=js"
export * from "./StatusRegion.vue?vue&type=script&lang=js"
script.render = render

export default script